import { useState } from "react";
import { api, ApiHatasi, mb, type KutuAyrinti } from "../api";
import { Bildirim, Durum, DurumRozeti, HataKutusu, Kart, Rozet, Tablo, TekSeferlik, useCek } from "../ui";

export function KutuDetay({ id, git }: { id: string; git: (y: string) => void }) {
  const kutu = useCek(() => api.kutu(id), [id]);
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [parola, setParola] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState<string | null>(null);
  const [aciklama, setAciklama] = useState<string | null>(null);
  const [yeniTakma, setYeniTakma] = useState("");

  async function calistir(ad: string, f: () => Promise<string | null>) {
    setHata(null);
    setBilgi(null);
    setBekliyor(ad);
    try {
      const m = await f();
      if (m) setBilgi(m);
      kutu.yenile();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(null);
    }
  }

  return (
    <Durum cekim={kutu}>
      {(d) => {
        const k: KutuAyrinti = d.veri;
        const silinmeyiBekliyor = k.panelDurum === "silinmeyi_bekliyor";
        return (
          <>
            <div className="baslik">
              <div>
                <h1>{k.emailAddress}</h1>
                <p>
                  {k.description ?? "Açıklama yok"} · {mb(k.usedDiskQuota ?? 0)} kullanılıyor
                </p>
              </div>
              <div className="eylemler">
                <button className="dugme" onClick={() => git("/kutular")}>
                  ← liste
                </button>
                <DurumRozeti durum={k.panelDurum ?? "aktif"} />
              </div>
            </div>

            {hata && <HataKutusu hata={hata} />}
            {bilgi && <Bildirim tur="iyi">{bilgi}</Bildirim>}
            {parola && (
              <TekSeferlik baslik={`${k.emailAddress} için yeni parola`} deger={parola} kapat={() => setParola(null)} />
            )}

            {silinmeyiBekliyor && (
              <Bildirim tur="kotu">
                <strong>Bu kutu silinmeyi bekliyor.</strong> {k.kaliciSilme} tarihinde kalıcı olarak silinecek.
                O tarihe kadar tek tıkla geri alabilirsiniz ve bu süre boyunca hiçbir posta kaybolmaz.
                <div style={{ marginTop: 10 }}>
                  <button
                    className="dugme ana"
                    disabled={bekliyor !== null}
                    onClick={() =>
                      calistir("geri", async () => (await api.kutuGeriAl(k.id)).mesaj)
                    }
                  >
                    {bekliyor === "geri" ? "Geri alınıyor…" : "Silmeyi geri al"}
                  </button>
                </div>
              </Bildirim>
            )}

            {k.panelDurum === "askida" && (
              <Bildirim tur="uyari">
                Bu kutu askıda. Giriş ve gönderim kapalı, <strong>gelen posta kabul edilmeye devam ediyor</strong>.
                {k.sebep ? ` Sebep: ${k.sebep}` : ""}
              </Bildirim>
            )}

            {(k.panelDurum === "gonderim_kilitli" || k.panelDurum === "dns_bekliyor") && (
              <Bildirim tur="uyari">
                {k.sebep ?? "Bu kutu geçici olarak kilitli."} Sorun giderildiğinde kilit kendiliğinden açılır.
              </Bildirim>
            )}

            <div className="izgara d2">
              <Kart baslik="Bilgiler">
                <div className="ic">
                  <Tablo basliklar={["Alan", "Değer"]}>
                    <tr>
                      <td>Adres</td>
                      <td className="tek">{k.emailAddress}</td>
                    </tr>
                    <tr>
                      <td>Açıklama</td>
                      <td>
                        {aciklama === null ? (
                          <span>
                            {k.description ?? "—"}{" "}
                            <button
                              className="dugme kucuk"
                              disabled={silinmeyiBekliyor}
                              onClick={() => setAciklama(k.description ?? "")}
                            >
                              değiştir
                            </button>
                          </span>
                        ) : (
                          <span style={{ display: "flex", gap: 6 }}>
                            <input
                              className="kucuk-girdi"
                              value={aciklama}
                              onChange={(e) => setAciklama(e.target.value)}
                              autoFocus
                            />
                            <button
                              className="dugme kucuk"
                              onClick={() =>
                                calistir("aciklama", async () => {
                                  await api.kutuGuncelle(k.id, { aciklama: aciklama ?? "" });
                                  setAciklama(null);
                                  return "Açıklama güncellendi.";
                                })
                              }
                            >
                              kaydet
                            </button>
                            <button className="dugme kucuk" onClick={() => setAciklama(null)}>
                              vazgeç
                            </button>
                          </span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Disk kullanımı</td>
                      <td className="sayi">{mb(k.usedDiskQuota ?? 0)}</td>
                    </tr>
                    <tr>
                      <td>Durum</td>
                      <td>
                        <DurumRozeti durum={k.panelDurum ?? "aktif"} />
                      </td>
                    </tr>
                  </Tablo>
                </div>
              </Kart>

              <Kart baslik={`Takma adlar (${k.takmaAdlar?.length ?? 0})`}>
                <div className="ic">
                  <p style={{ color: "var(--n-600)", marginTop: 0, fontSize: 13 }}>
                    Takma adlara gelen postalar bu kutuya düşer. Ayrı bir kutu açmadan ikinci bir adres
                    vermek için kullanılır.
                  </p>
                  {(k.takmaAdlar ?? []).length === 0 ? (
                    <div className="bos">Takma ad yok</div>
                  ) : (
                    <Tablo basliklar={["Takma ad", ""]}>
                      {(k.takmaAdlar ?? []).map((a) => (
                        <tr key={a}>
                          <td className="tek">{a}</td>
                          <td>
                            <button
                              className="dugme kucuk tehlike"
                              disabled={bekliyor !== null || silinmeyiBekliyor}
                              onClick={() =>
                                calistir("takma", async () => (await api.takmaAdSil(k.id, a)).mesaj)
                              }
                            >
                              kaldır
                            </button>
                          </td>
                        </tr>
                      ))}
                    </Tablo>
                  )}
                  <div style={{ display: "flex", gap: 6, marginTop: 12 }}>
                    <input
                      className="kucuk-girdi"
                      placeholder="yeni takma ad"
                      value={yeniTakma}
                      onChange={(e) => setYeniTakma(e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g, ""))}
                      style={{ flex: 1 }}
                    />
                    <button
                      className="dugme"
                      disabled={!yeniTakma || bekliyor !== null || silinmeyiBekliyor}
                      onClick={() =>
                        calistir("takma", async () => {
                          const y = await api.takmaAdEkle(k.id, yeniTakma);
                          setYeniTakma("");
                          return y.mesaj;
                        })
                      }
                    >
                      ekle
                    </button>
                  </div>
                </div>
              </Kart>
            </div>

            <div style={{ marginTop: 16 }}>
              <Kart baslik="İşlemler">
                <div className="ic" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
                    className="dugme"
                    disabled={bekliyor !== null || silinmeyiBekliyor}
                    onClick={() =>
                      calistir("parola", async () => {
                        const y = await api.kutuParola(k.id);
                        setParola(y.parola);
                        return null;
                      })
                    }
                  >
                    {bekliyor === "parola" ? "Üretiliyor…" : "Yeni parola üret"}
                  </button>

                  {k.panelDurum === "askida" ? (
                    <button
                      className="dugme ana"
                      disabled={bekliyor !== null}
                      onClick={() => calistir("durum", async () => (await api.kutuAktifEt(k.id)).mesaj)}
                    >
                      Yeniden aç
                    </button>
                  ) : (
                    <button
                      className="dugme"
                      disabled={bekliyor !== null || silinmeyiBekliyor}
                      onClick={() => {
                        const sebep = window.prompt("Askıya alma sebebi:", "İzinli personel");
                        if (sebep === null) return;
                        calistir("durum", async () => (await api.kutuAskiyaAl(k.id, sebep)).mesaj);
                      }}
                    >
                      Askıya al
                    </button>
                  )}

                  {!silinmeyiBekliyor && (
                    <button
                      className="dugme tehlike"
                      disabled={bekliyor !== null}
                      onClick={() => {
                        if (
                          !window.confirm(
                            `${k.emailAddress} silinsin mi?\n\n` +
                              "Kutu hemen yok edilmez: 30 gün boyunca geri alabilirsiniz ve bu süre " +
                              "boyunca hiçbir posta kaybolmaz.",
                          )
                        )
                          return;
                        calistir("sil", async () => (await api.kutuSil(k.id)).mesaj);
                      }}
                    >
                      Sil
                    </button>
                  )}
                </div>
              </Kart>
            </div>
          </>
        );
      }}
    </Durum>
  );
}
